import { Component, OnDestroy } from "@angular/core";
import {
  Event,
  Router,
  NavigationStart,
  NavigationEnd} from "@angular/router";
import { PlatformLocation } from "@angular/common";
// import { NgcCookieConsentService, NgcInitializeEvent, NgcNoCookieLawEvent, NgcStatusChangeEvent } from 'ngx-cookieconsent';
import { Subscription } from 'rxjs';

import { LoaderService } from './services/loader.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { NewAuditService } from './services/new-audit.service';
import { UserService } from "./services/user.service";
import { FcmMessagingService } from "./services/fcm-messaging-service.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"]
})
export class AppComponent implements OnDestroy {
  currentUrl: string;
  showLoadingIndicatior = true;
  showHeaderAndSidebar: boolean = false;
  deviceInfo: any;
  showMobileAppOption: boolean = false;
  incidentMobile: boolean = false;
  isNearMissPage: boolean = false;
  //keep refs to subscriptions to be able to unsubscribe later
  private popupOpenSubscription!: Subscription;
  private popupCloseSubscription!: Subscription;
  private initializingSubscription!: Subscription;
  private initializedSubscription!: Subscription;
  private initializationErrorSubscription!: Subscription;
  private statusChangeSubscription!: Subscription;
  private revokeChoiceSubscription!: Subscription;
  private noCookieLawSubscription!: Subscription;

  constructor(public _router: Router,
    private incidentService: NewAuditService,
    location: PlatformLocation, 
    public loaderService: LoaderService, 
    private deviceService: DeviceDetectorService, 
    private newAuditServie: NewAuditService, 
    // private ccService: NgcCookieConsentService,
    private userService: UserService,
    private fcmservice: FcmMessagingService
    ) {
    //console.log(navigator.userAgent);
    //console.log(this.showMobileAppOption, 'showMobileAppOption');
    //device: iPad, device: iOS, device: Android, os: Android
    this.deviceInfo = this.deviceService.getDeviceInfo();
    const isOpenApp = localStorage.getItem('openAppClicked');
    const ismobile = localStorage.getItem("ismobile");

    if (ismobile == "true") {
      this.incidentMobile = true;
      this.showMobileAppOption = false;
      this.newAuditServie.appClosedUpdate(true);
    } else {
      this.incidentMobile = false;
    }
    //console.log('openAppClicked', isOpenApp);
    // this.incidentService.isIncident.subscribe(res => {
    //   if(res === true) {
    //     this.incidentMobile = true
    //   } else {
    //     this.incidentMobile = false;
    //   }
    // })


    if (window.innerWidth < 769) {
      if (!isOpenApp && (this.deviceInfo.os === 'Android' || this.deviceInfo.os === 'iOS' || (this.deviceInfo.os === 'iOS' && this.deviceInfo.device === 'iPad'))) {
        this.showMobileAppOption = true;
      } else if (!isOpenApp && (this.deviceInfo.device === 'iPad' && this.deviceInfo.os === 'Mac' && window.innerWidth < 769)) {
        this.showMobileAppOption = true;
      } else {
        this.showMobileAppOption = false;
      }
    } else {
      this.showMobileAppOption = false;
    }

    this._router.events.subscribe((routerEvent: Event) => {
      if (routerEvent instanceof NavigationStart) {
        this.showLoadingIndicatior = true;
        location.onPopState(() => {
          window.location.reload();
        });
        this.currentUrl = routerEvent.url.substring(
          routerEvent.url.lastIndexOf("/") + 1
        );

         localStorage.setItem('CURRENT_URL', this.currentUrl)
        
        // Check if it's a near miss page
        this.isNearMissPage = routerEvent.url.includes('/near-miss/');
        
        if (this.currentUrl === 'simlogin' || this.currentUrl === 'home'|| this.currentUrl.search("error_display")!=-1 || this.currentUrl === 'signin' || this.currentUrl === 'forgot-password' || this.currentUrl === 'register' || this.currentUrl.indexOf('register?REF_CODE=') > -1 || this.currentUrl === 'account' || this.currentUrl === 'two-factor-authentication' || this.currentUrl === 'otp-confirmation' || this.currentUrl === 'sso-login' || this.currentUrl === 'verify-otp' || this.currentUrl.indexOf('pin-verification') > -1 || routerEvent.url.includes('/near-miss/questionnaire/')) {
          this.showHeaderAndSidebar = false;
        } else {
          this.showHeaderAndSidebar = true;
        }
      }
      if (routerEvent instanceof NavigationEnd) {
        this.showLoadingIndicatior = false;
      }
      window.scrollTo(0, 0);
    });
    
    // Check if user is accessing pin-verification page (from QR code)
    const currentUrl = window.location.hash || window.location.href;
    const isPinVerificationPage = currentUrl.includes('pin-verification');
    const skipAuthCheck = localStorage.getItem('skip_auth_check');
    const getAllowSignIn = localStorage.getItem('allow_Signin');
    
    // Don't redirect if accessing pin-verification page from QR code
    if(getAllowSignIn == 'false' && skipAuthCheck !== 'true' && !isPinVerificationPage) {
      this.userService.signOutOfApp();
    }

  }

   // ngOnInit() {
    // // subscribe to cookieconsent observables to react to main events
    // this.popupOpenSubscription = this.ccService.popupOpen$.subscribe(
    //   () => {
    //     // you can use this.ccService.getConfig() to do stuff...
    //   });

    // this.popupCloseSubscription = this.ccService.popupClose$.subscribe(
    //   () => {
    //     // you can use this.ccService.getConfig() to do stuff...
    //   });

    // this.initializingSubscription = this.ccService.initialize$.subscribe(
    //   (event: NgcInitializeEvent) => {
    //     // the cookieconsent is initilializing... Not yet safe to call methods like `NgcCookieConsentService.hasAnswered()`
    //     console.log(`initializing: ${JSON.stringify(event)}`);
    //   });

    // this.initializedSubscription = this.ccService.initialize$.subscribe(
    //   () => {
    //     // the cookieconsent has been successfully initialized.
    //     // It's now safe to use methods on NgcCookieConsentService that require it, like `hasAnswered()` for eg...
    //     console.log(`initialized: ${JSON.stringify(event)}`);
    //   });

    // // this.initializationErrorSubscription = this.ccService.initializationError$.subscribe(
    // //   (event: NgcInitializationErrorEvent) => {
    // //     // the cookieconsent has failed to initialize... 
    // //     console.log(`initializationError: ${JSON.stringify(event.error?.message)}`);
    // //   });

    // this.statusChangeSubscription = this.ccService.statusChange$.subscribe(
    //   (event: NgcStatusChangeEvent) => {
    //     // you can use this.ccService.getConfig() to do stuff...
    //   });

    // this.revokeChoiceSubscription = this.ccService.revokeChoice$.subscribe(
    //   () => {
    //     // you can use this.ccService.getConfig() to do stuff...
    //   });

    // this.noCookieLawSubscription = this.ccService.noCookieLaw$.subscribe(
    //   (event: NgcNoCookieLawEvent) => {
    //     // you can use this.ccService.getConfig() to do stuff...
    //   });
  // }

  ngOnDestroy() {
    // unsubscribe to cookieconsent observables to prevent memory leaks
    this.popupOpenSubscription.unsubscribe();
    this.popupCloseSubscription.unsubscribe();
    this.initializingSubscription.unsubscribe();
    this.initializedSubscription.unsubscribe();
    this.initializationErrorSubscription.unsubscribe();
    this.statusChangeSubscription.unsubscribe();
    this.revokeChoiceSubscription.unsubscribe();
    this.noCookieLawSubscription.unsubscribe();
  }

  closeAppNotif() {
    this.showMobileAppOption = false;
    this.newAuditServie.appClosedUpdate(true);
  }

  openApp() {
    //alert();
    //localStorage.setItem('openAppClicked', JSON.stringify(true));
    this.showMobileAppOption = false;
    this.newAuditServie.appOpenUpdate(true);
  }

}
